<template>
  <v-row>
    <v-col cols="12" class="text-h6 pt-4 pl-5">
        <h4 class="font-weight-medium kbDarkBlueText--text mr-4 text-capitalize"
            style="display: inline;">{{ $t('general.statsPerApp') }}</h4>
    </v-col>

    <v-col cols="12" sm="6" class="py-0 pl-5">
      <v-text-field color='kbDarkBlueText'
                    append-icon="search"
                    v-model='searchStatsPerAppValue'
                    :placeholder="$t('general.search')"
                    clearable>
        <template v-slot:append-outer>
          <v-icon class='ml-2'
                  color="kbDarkBlueText"
                  @click="btnResetStatsPerApp()">refresh</v-icon>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12">
        <v-data-table
            :headers='headers'
            :items='filteredStatsPerApp'
            :footer-props="{
            'items-per-page-text': $t('general.applicationsPerPage'),
            'items-per-page-options': [10, 50, 100]
          }"
            :options.sync='options'
            class='elevation-2 mx-2'>
            <template v-slot:item="{ item }">
                <tr>
                    <td class="font-weight-bold text-capitalize">{{ item.appName || $t('general.noName') }}</td>
                    <td class="text-center">{{ item.users || 0 }}</td>
                    <td class="text-center">{{ item.smsSent || 0 }}</td>
                    <td class="text-center">{{ item.smsNumparts || 0 }}</td>
                    <td class="text-center">{{ item.emailSent || 0 }}</td>
                </tr>
            </template>

            <template slot='no-data'>
                <v-row>
                    <v-col cols="12" class="red--text text-center">{{ $t('general.noAppsToShow') }}</v-col>
                </v-row>
            </template>
        </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      language: state => state.auth.language
    })
  },
  props: {
    statsPerApp: {
      type: Array,
      required: true
    },
    totalApps: {
      type: Number,
      required: true
    }
  },
  methods: {
    searchStatsByApp (appName) {
      return new Promise((resolve, reject) => {
        try {
          appName = appName.toLowerCase()
          const result = []
          this.statsPerApp.find(app => {
            const searchRes = app.appName.toLowerCase().search(appName)
            if (searchRes >= 0) {
              result.push(app)
            }
          })
          if (result.length > 0) {
            return resolve(result)
          }
        } catch (error) {
          console.log(error)
          return reject(error)
        }
        return reject(new Error('Search has no results'))
      })
    },
    btnResetStatsPerApp () {
      this.resetSearchFields()
      this.resetStatsPerApp()
    },
    setStatsPerApp2Table (data) {
      if (data) {
        this.filteredStatsPerApp = data
      } else {
        this.filteredStatsPerApp = []
      }
    },
    resetStatsPerApp () {
      this.setStatsPerApp2Table(this.statsPerApp)
    },
    resetSearchFields () {
      this.searchStatsPerAppValue = ''
    }
  },
  data: function () {
    return {
      searchStatsPerAppValue: '',
      headers: [
        { text: this.$t('general.name'), value: 'appName', sortable: true },
        { text: this.$t('general.people'), value: 'users', align: 'center', sortable: true },
        { text: this.$t('general.sentMessages'), value: 'smsSent', align: 'center', sortable: true },
        { text: this.$t('general.messagesParts'), value: 'smsNumparts', align: 'center', sortable: true },
        { text: this.$t('general.sentEmails'), value: 'emailSent', align: 'center', sortable: true }
      ],
      options: { sortBy: ['users'], sortDesc: [true] },
      filteredStatsPerApp: this.statsPerApp
    }
  },
  watch: {
    language () {
      this.headers[0].text = this.$t('general.name')
      this.headers[1].text = this.$t('general.people')
      this.headers[2].text = this.$t('general.sentMessages')
      this.headers[3].text = this.$t('general.messagesParts')
      this.headers[4].text = this.$t('general.sentEmails')
    },
    searchStatsPerAppValue: function (val, oldVal) {
      if (val) {
        this.searchStatsByApp(val).then((result) => {
          this.setStatsPerApp2Table(result)
        }).catch(() => {
          this.setStatsPerApp2Table()
        })
      } else {
        this.resetStatsPerApp()
      }
    }
  }
}
</script>

<style>
.small {
  width: 100%;
  max-height: 100px;
}
</style>
